/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {IxModule} from '@siemens/ix-angular';
import {File, SubmodelElement} from '@product-passport/dpp/model';
import {TranslateOrFallbackPipe} from '../../../dpp-submodel-field/utils/translate-or-fallback.pipe';
import {DppFieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  imports: [
    IxModule,
    ReactiveFormsModule,
    DppFieldLabelComponent,
    TranslateModule,
    TranslateOrFallbackPipe,
  ],
})
export class FileComponent {
  @Input({required: true}) element!: SubmodelElement;
  @Input({required: true}) control!: AbstractControl;

  get file(): File {
    return this.element as File;
  }
  get formControl(): FormControl {
    return this.control as FormControl;
  }
}
